module.exports = __webpack_public_path__ + "img/img_device_zt102.f5b18aa8.png";